@if (data !== null) {
    <div class="row px-3 px-lg-0">
        <div class="col-12 col-sm-6">
            <select class="custom-select border-light2 mb-1" [(ngModel)]="year" (change)="onYearChange($event)">
                @for (y of data.available_years; track $index) {
                    <option [value]="y">
                        {{ y }}
                    </option>
                }
            </select>
        </div>
    </div>
    <h4 class="head mt-3 ml-2 ml-xl-0">{{ 'web.free-agents' | translate }} {{ year }}</h4>
    <div class="d-flex table-scrollable">
        <div class="table-scrollable__data flex-grow-1">
            <table class="table-scrollable__data__table" data-cy="app-table-left-data">
                <thead>
                    <tr>
                        <th class="table-scrollable__table-th" colspan="2">
                            {{ 'web.player' | translate }}
                        </th>
                        <th class="table-scrollable__table-th">
                            {{ 'web.position' | translate }}
                        </th>
                        <th class="table-scrollable__table-th">
                            {{ 'web.height' | translate }}
                        </th>
                        <th class="table-scrollable__table-th">
                            {{ 'web.weight' | translate }}
                        </th>
                        @if (hasHighSchool) {
                            <th class="table-scrollable__table-th">
                                {{ 'web.high_school' | translate }}
                            </th>
                        }
                        @if (hasCollege) {
                            <th class="table-scrollable__table-th">
                                {{ 'web.college' | translate }}
                            </th>
                        }
                    </tr>
                </thead>
                <tbody>
                    @for (row of visibleRows; track trackByFreeAgent($index, row)) {
                        <tr class="table-scrollable__table-row">
                            <td class="table-scrollable__table-td text-center" style="width: 55px">
                                <div class="img-circle img-circle--40 mr-3 rounded-circle">
                                    <img
                                        (error)="imageError($event, 'avatar')"
                                        [attr.alt]="row.playerName"
                                        [src]="'/assets/players/photos/' + row.playerId + '.png'"
                                        height="40"
                                        loading="lazy"
                                    />
                                </div>
                            </td>
                            <td class="table-scrollable__table-td">
                                @if (row.playerId) {
                                    <a [routerLink]="row.playerLink" class="text-reset table-scrollable-team">
                                        {{ row.playerName }}
                                    </a>
                                } @else {
                                    {{ row.playerName }}
                                }
                            </td>
                            <td class="table-scrollable__table-td">
                                <ng-container *ngIf="row.playerPosition; else noposition">
                                    {{ 'web.position_' + sportName + '_' + row.playerPosition | lowercase | translate }}
                                </ng-container>
                                <ng-template #noposition> &nbsp;</ng-template>
                            </td>
                            <td class="table-scrollable__table-td">
                                @if (row.playerHeight) {
                                    {{ row.playerHeight }}
                                }
                            </td>
                            <td class="table-scrollable__table-td">
                                @if (row.playerWeight) {
                                    {{ row.playerWeight }}
                                }
                            </td>
                            @if (hasHighSchool) {
                                <td class="table-scrollable__table-td">
                                    {{ row.highSchool }}
                                </td>
                            }
                            @if (hasCollege) {
                                <td class="table-scrollable__table-td">
                                    {{ row.college }}
                                </td>
                            }
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    @if (hasMoreRows()) {
        <div #loadMoreTrigger class="mt-3" style="height: 1px"></div>
    }
} @else {
    <app-placeholder-table></app-placeholder-table>
}
